import { useSelector, useDispatch } from 'react-redux';
import gameplaySlice from './gameplaySlice';

function useGameplay() {
    const { gameplay } = useSelector((state) => {
        return state.gameplay;
    });
    const dispatch = useDispatch();

    function setGameplay(gameplay) {
        dispatch(gameplaySlice.actions.setGameplay(gameplay));
    }

    return { gameplay, setGameplay };
}

export default useGameplay;